module.exports = __webpack_public_path__ + "img/logo_mini.9b7b0561.svg";